import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
// eslint-disable-next-line import/no-cycle
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from '@/auth/utils'

import dashboard from './routes/dashboard'
import paymentMethod from './routes/payment-methods'
import courierService from './routes/courier-services'
import product from './routes/product'
import user from './routes/user'
import role from './routes/role'
import brand from './routes/brand'
import banner from './routes/banner'
import voucher from './routes/voucher'
import category from './routes/category'
import faq from './routes/faq'
import faqCategory from './routes/faqCategory'
import transaction from './routes/transaction'
import collection from './routes/collection'
import permission from './routes/permission'
import auth from './routes/auth'
import notification from './routes/notification'
import setting from './routes/setting'
import review from './routes/review'
import article from './routes/article'
import articleCategory from './routes/articleCategory'
import affiliate from './routes/affiliate'
import chat from './routes/chat'
import image from './routes/image'
import sale from './routes/sale'
import transactionsV2 from './routes/v2/transactions'
import voucherUsageV2 from './routes/v2/voucher-usages'
import administratorV2 from './routes/v2/administrators'
import voucherV2 from './routes/v2/vouchers'
import userV2 from './routes/v2/users'
import bannersV2 from './routes/v2/banners'
import brandsV2 from './routes/v2/brands'
import categoriesV2 from './routes/v2/categories'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...dashboard,
    ...product,
    ...user,
    ...role,
    ...brand,
    ...banner,
    ...auth,
    ...voucher,
    ...category,
    ...faq,
    ...faqCategory,
    ...transaction,
    ...collection,
    ...permission,
    ...notification,
    ...setting,
    ...review,
    ...article,
    ...articleCategory,
    ...affiliate,
    ...chat,
    ...image,
    ...sale,
    ...transactionsV2,
    ...bannersV2,
    ...brandsV2,
    ...categoriesV2,
    ...userV2,
    ...voucherV2,
    ...administratorV2,
    ...voucherUsageV2,
    ...paymentMethod,
    ...courierService,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to) && !isLoggedIn) {
    // Redirect to login jika belum masuk
    const redirectTo = to.name === 'login' ? undefined : to.fullPath
    if (redirectTo) {
      return next({ name: 'login', query: { redirectTo } })
    }
    return next({ name: 'login' })
  }

  // Redirect if logged in
  if ((to.meta.redirectIfLoggedIn && isLoggedIn) || (!canNavigate(to) && isLoggedIn && !to.meta.preventRedirect)) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData.role))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
